import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import About from "./pages/About";
import EnrichIQPage from "./pages/EnrichIQ";
import AALIGNPage from "./pages/AALIGN";
import AudienceIntelligencePage from "./pages/AudienceIntelligence";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";
import DoNotSell from "./pages/DoNotSell";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminBlog from "./pages/admin/AdminBlog";
import AdminBlogEditor from "./pages/admin/AdminBlogEditor";
import AdminSettings from "./pages/admin/AdminSettings";
import ScrollToTop from "./components/site/ScrollToTop";
import CookieBanner from "./components/site/CookieBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<About />} />
          <Route path="/products/enrich-iq" element={<EnrichIQPage />} />
          <Route path="/products/aalign" element={<AALIGNPage />} />
          <Route path="/products/audience-intelligence" element={<AudienceIntelligencePage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/do-not-sell" element={<DoNotSell />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/blog" element={<AdminBlog />} />
          <Route path="/admin/blog/new" element={<AdminBlogEditor />} />
          <Route path="/admin/blog/:slug/edit" element={<AdminBlogEditor />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
